import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "../components/Head";
import "./style/content.css";

// Neznámá adresa: stránka s noindex, aby se do vyhledávačů nedostávaly kopie úvodní stránky.
export default function NotFoundPage() {
  return (
    <main className="content-page">
      <Helmet>
        <title>Stránka nenalezena | FinPilot</title>
        <meta name="description" content="Tato stránka na FinPilotu neexistuje." />
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <span className="content-kicker">404</span>
      <h1>Tuhle stránku jsme nenašli</h1>
      <p>Adresa neexistuje nebo se změnila. Zkuste některou z těchto stránek:</p>
      <ul>
        <li><Link to="/">Úvodní stránka</Link></li>
        <li><Link to="/oborove-statistiky">Oborové statistiky</Link></li>
        <li><Link to="/benchmark-obory">Benchmark oborů</Link></li>
        <li><Link to="/obory">Přehled oborů</Link></li>
        <li><Link to="/blog">Blog</Link></li>
      </ul>
    </main>
  );
}
